import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { BaseLink, ILinkProps } from '../BaseLink/BaseLink';
import { defaultCardStyle } from '../../Styles';

export type BaseLinkCardProps = Pick<ILinkProps, 'className' | 'to' | 'href' | 'tabIndex' | 'target' | 'replace'> & {
  onCardClick?: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const StyledBaseLink = styled(BaseLink)`
  ${defaultCardStyle}
  color: unset;
  :hover,
  :active,
  :focus,
  :visited,
  :active:hover {
    color: unset;
    text-decoration: none;
  }
`;

export const BaseLinkCard: FunctionComponent<BaseLinkCardProps> = props => {
  const { children, onCardClick, ...otherProps } = props;
  return (
    <StyledBaseLink onClick={onCardClick} {...otherProps}>
      {children}
    </StyledBaseLink>
  );
};
